import React from 'react'
import { MapContainer, TileLayer, Marker, Popup, Polygon } from 'react-leaflet'
import L, { LatLngExpression } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import icon from 'leaflet/dist/images/marker-icon.png'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'

let polygon: LatLngExpression[] = [
[32.73813, -97.131995],
[33.189838, -96.820592],
[33.535136, -96.608428],
[33.620141, -96.178301],
[33.72079, -95.551608],
[33.198337, -95.224518],
[32.952786, -95.264414],
[32.646511, -95.470146],
[32.31712, -96.16616],
[32.547375, -96.821841]
]
const MyMap = () => {
const myAPIKey = 'b12c3c6df2bc4a818599ffa953661209'
let baseUrl = `https://tile.thunderforest.com/cycle/{z}/{x}/{y}.png?apikey=${
    myAPIKey
}`
let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
})
L.Marker.prototype.options.icon = DefaultIcon
var marker = L.marker([33.02855, -96.43431])
marker.bindPopup('Lavon,TX').openPopup()

return (
    <MapContainer
    style={{ height: '500px', width: '100%' }}
    center={[33.02855, -96.43431]}
    zoom={8}
    >
    <TileLayer
        attribution="<a href=&quot;https://www.thunderforest.com/&quot;>ThunderForest</a> contributors"
        url={baseUrl}
    />
    <Polygon positions={polygon} />
    <Marker position={[33.02855, -96.43431]}>
        <Popup>Tangled Lead Fencing & Welding</Popup>
    </Marker>
    </MapContainer>
)
}

export default MyMap
